import { render, staticRenderFns } from "./ValidationsPage.vue?vue&type=template&id=354a46fc&scoped=true"
import script from "./ValidationsPage.vue?vue&type=script&lang=js"
export * from "./ValidationsPage.vue?vue&type=script&lang=js"
import style0 from "./ValidationsPage.vue?vue&type=style&index=0&id=354a46fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a46fc",
  null
  
)

export default component.exports